/**
 * Created by OLD on 31/08/2015.
 */
define('customerAllMessagesMessagesView',[
  'module',
  'underscore',
  'marionette',
  'app',
  'settings',
  'dateUtils',
  'template!customerAllMessagesTpl',
  'stateMessages',
  'rolesMixin',
  'zoomPopover'
], function(
  module,
  _,
  Marionette,
  App,
  Settings,
  dateConverter,
  viewTpl,
  StateMessages,
  RolesMixin,
  ZoomPopoverBehavior
) {
  'use strict';

  var MessagesView =  Marionette.ItemView.extend({
    template: viewTpl,

    ui: {
      toolTip: '[data-toggle="tooltip"]',
      imageCells: '.js-image-cell',
      attachmentFiles: '.js-attachment-file'
    },

    behaviors: {
      ZoomPopover: {
        behaviorClass: ZoomPopoverBehavior,
        manualInit: true,
        container: '.message-container'
      }
    },

    serializeData: function() {
      var templateData = [];
      if (this.model) {
        templateData = this.model.toJSON();
        templateData.time = dateConverter.toTimeFormatString(templateData.date);
        templateData.day = dateConverter.toDateFormatString(templateData.date);
        if (templateData.firstMandrillClick) {
          templateData.timeMandrillClick = dateConverter.toTimeFormatString(templateData.firstMandrillClick);
          templateData.dayMandrillClick = dateConverter.toDateFormatString(templateData.firstMandrillClick);
        }
        if (templateData.firstMandrillOpen) {
          templateData.timeMandrillOpen = dateConverter.toTimeFormatString(templateData.firstMandrillOpen);
          templateData.dayMandrillOpen = dateConverter.toDateFormatString(templateData.firstMandrillOpen);
        }
        templateData.content = templateData.content || '';
        _.each(templateData.attachements, function (item) {
          if (item.fileLink) {
            item.fileLink = Settings.url('base', item.fileLink);
          }
          if (item.downloadLink && window.location.href.indexOf('https') === 0) {
            item.downloadLink = item.downloadLink.replace('http:', 'https:');
          }
        });

        if (templateData.userPid && templateData.userPid.logonId) {
          templateData.user = templateData.userPid.logonId;
        } else {
          templateData.user = '';
        }

        if (templateData.userPid && templateData.userPid.logo) {
          templateData.fileUrl = Settings.url('file', templateData.userPid.logo, {size: 'thumbnail'});
        } else {
          templateData.fileUrl = null;
        }
      } else {
        this.model = [];
        this.model.attachements = [];
      }

      return templateData;
    },

    onShow: function() {
      $.material.init();
      this.showAttachments();
      this.ui.toolTip.tooltip();
    },

    showAttachments: function() {
      var that = this,
          counter = 0,
          attachements = this.model.get('attachments');
      _.each(attachements, function(item, index) {
        var imageCell, attachmentFile;
        if(item.fileLink) {
          imageCell = that.ui.imageCells.filter('.js-' + index);
          attachmentFile = that.ui.attachmentFiles.filter('.js-' + index);
          $('<img/>').attr('src', Settings.url('base', item.fileLink)).load(function() {
            $(this).remove();
            imageCell.css('background-image', 'url(' + Settings.url('base', item.fileLink) + ')');
            imageCell.show();
            that.triggerMethod('show:image:zoom:popover', item.fileLink, imageCell);
            counter++;
            that.checkAttCounter(attachements,counter);
          }).error(function() {
            counter++;
            that.checkAttCounter(attachements,counter);
            $(this).remove();
            attachmentFile.show();
          });
        }
      });
      if (attachements && attachements.length === 0){
        this.trigger('attachedViewShown');
      }
    },

    //trigger it only once for message when images have loaded
    checkAttCounter: function(attachements,counter) {
      var length = attachements.length;
      if (length === counter) {
        this.trigger('attachedViewShown');
      }
    },

    onBeforeDestroy: function() {
      if (this.ui.toolTip.toolTip) {
        this.ui.toolTip.tooltip('destroy');
      }
    }
  });

  module.exports = MessagesView;
});

